import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { useApi, useToaster } from '@shopexperts/shared';

interface SyncBadgesToExpertParams {
  expertId: number;
  badge_ids: number[];
}

export function useSyncBadgesToExpert() {
  const api = useApi();
  const toaster = useToaster();
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['admin', 'badges', 'syncToExpert'],
    mutationFn: async ({ expertId, badge_ids }: SyncBadgesToExpertParams) => {
      return await api.admin.badges.syncBadgesToExpert({
        params: { expertId },
        body: { badge_ids },
      });
    },
    onSuccess: () => {
      toaster.create({
        title: 'Badge assigned successfully',
        type: 'success',
      });
      
      // Invalidate expert search cache to refresh badge counts
      queryClient.invalidateQueries({ 
        queryKey: ['admin', 'experts', 'quickSearch'] 
      });
    },
    onError: (error) => {
      console.error('[useSyncBadgesToExpert] Error:', error);
      toaster.create({
        title: 'Failed to assign badge',
        description: 'Please try again later',
        type: 'error',
      });
    },
  });

  return {
    mutateAsync,
    isPending,
  };
}

